// extracted by mini-css-extract-plugin
module.exports = {"collections":"collections_collections__rakcZ"};